import styled from "styled-components";

export const AppWrapper = styled.div`
  /* width: calc(100% - 100px); */
  /* width: 100%; */
  min-height: 100vh;
  margin: 0 auto;
  position: relative;
  background-color: #232323;
`;
export const AppChildrenWrapper = styled.div`
  /* width: calc(100% - 100px);
  margin: 0 auto; */
  padding: 0 50px;
  @media (max-width: 600px) {
    padding: 0 25px;
  }
`;
